import { render, staticRenderFns } from "./AddOffer.vue?vue&type=template&id=2b704cc2&scoped=true&"
import script from "./AddOffer.vue?vue&type=script&lang=js&"
export * from "./AddOffer.vue?vue&type=script&lang=js&"
import style0 from "./AddOffer.vue?vue&type=style&index=0&id=2b704cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b704cc2",
  null
  
)

export default component.exports